import React, { FunctionComponent, useEffect, useState } from "react";
import { IAPIResponse } from "../../Redux/interfaces/IAPIResponse";
import Dialog from "../Dialog/Dialog";
import { SvgIcon, Typography } from "@mui/material";
import ButtonField from "../Button/ButtonField";
import "./ResponseDialog.scss";
import { ReactComponent as success } from "../../Assets/Images/success.svg";
import { ReactComponent as failure } from "../../Assets/Images/failure.svg";
import { ReactComponent as warningIcon } from "../../Assets/Images/warning.svg";

interface ResponseDialogProps {
  response?: IAPIResponse<any>;
  parentDialog?: React.Dispatch<React.SetStateAction<boolean>>;
  okFunction?: () => void;
  okText?: string;
  onOkClick?: () => void;
  customMessage?: string;
  warning?: boolean;
}

const ResponseDialog: FunctionComponent<ResponseDialogProps> = (props) => {
  const { okFunction, parentDialog, response, okText, onOkClick, customMessage, warning } = props;
  const [open, setOpen] = useState<boolean>(false);
  console.log("response dialoge called", response);

  const handleClose = () => {
    setOpen(false);
    if (onOkClick) {
      onOkClick();
    } else {
      response?.status && parentDialog && parentDialog(false);
      okFunction && response?.status && okFunction();
    }
  };

  useEffect(() => {
    if (response && Object.keys(response).length !== 0) {
      setOpen(true);
    }
  }, [response]);

  return (
    <Dialog
      open={open}
      dialogContentClassName="response_content"
      Dialog_Content={
        <>
          <SvgIcon
            component={warning ? warningIcon : (response?.status ? success : failure)}
            inheritViewBox
            className="response_icon"
          />
          <Typography variant="body1" sx={{ fontWeight: 500, mt: 1 }}>
            {customMessage || response?.message || (response?.status === true ? "Successfully processed" : (response?.status === false ? "Process failed" : ""))}
          </Typography>
        </>
      }
      Dialog_Actions={
        <ButtonField className="response_ok_btn" onClick={() => handleClose()}>
          {okText || "Ok"}
        </ButtonField>
      }
    />
  );
};

export default ResponseDialog;
